// extracted by mini-css-extract-plugin
export default {"root":"VideoBackground_root__OXFNT","videoContent":"VideoBackground_videoContent__Q2iwQ","overlayContent":"VideoBackground_overlayContent__NpxRS"};